import React, { FC } from 'react'
import { IconBaseProps } from 'react-icon-base'
import { StyledIcon } from './styled-icon'

export const CsVulnerabilityIcon: FC<IconBaseProps> = (props) => (
  <StyledIcon viewBox="0 0 1024 1024" {...props}>
    <g>
      <path d="M585.143 794.857V686.286q0-8-5.429-13.429t-12.857-5.429H457.143q-7.429 0-12.857 5.429t-5.429 13.429v108.571q0 8 5.429 13.429t12.857 5.429h109.714q7.429 0 12.857-5.429t5.429-13.429zM584 581.143l10.286-262.286q0-6.857-5.714-10.857-7.429-6.286-13.714-6.286H449.144q-6.286 0-13.714 6.286-5.714 4-5.714 12l9.714 261.143q0 5.714 5.714 9.429t13.714 3.714h105.714q8 0 13.429-3.714t6-9.429zm-8-533.714L1014.857 852q20 36-1.143 72-9.714 16.571-26.571 26.286T950.857 960H73.143q-19.429 0-36.286-9.714T10.286 924q-21.143-36-1.143-72L448 47.429q9.714-17.714 26.857-28T512 9.143t37.143 10.286 26.857 28z" />
    </g>
  </StyledIcon>
)

CsVulnerabilityIcon.displayName = 'CsVulnerabilityIcon'
